// @mui
import { Typography, Stack, Box } from '@mui/material';
// components
import Logo from '../../components/logo';
import Image from '../../components/image';
//
import { StyledRoot, StyledContent } from './styles';

// ----------------------------------------------------------------------

type Props = {
  title?: string;
  illustration?: string;
  children: React.ReactNode;
};

export default function LoginLayout({ children, title, illustration }: Props) {
  return (
    <StyledRoot>
      <StyledContent>
        <Stack spacing={3} sx={{ mb: 3, alignItems: 'center' }}>
          <Box component="img" src="/logo/logoFull.png" sx={{ height: 64, objectFit: 'contain' }} alt="AI-LYN Logo" />
        </Stack>
        <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContent>
    </StyledRoot>
  );
}
